import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-nm-dark text-slate-700 py-12 sm:py-16 relative overflow-hidden border-t border-slate-200/20">
      {/* Background visual texture */}
      <div 
        className="absolute inset-0 opacity-15 pointer-events-none" 
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C6A25E' fill-opacity='0.08'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div>
            <a href="/" className="flex items-center space-x-3 mb-5">
              <img 
                src="/logo-main.webp" 
                alt="Cervello Eduverse Logo" 
                className="w-11 h-11 rounded-full object-cover border-2 border-[#C6A25E] shadow-lg flex-shrink-0"
                loading="lazy"
              />
              <div className="text-xl font-bold bg-gradient-to-r from-[#C6A25E] to-[#87CEEB] bg-clip-text text-transparent">
                Cervello Eduverse
              </div>
            </a>
            <p className="text-sm text-slate-600 mb-5 max-w-[280px] font-light">
              Transforming education for the future with conceptual learning, expert mentorship, and industry-oriented experience.
            </p>
            <div className="flex space-x-3">
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/cervello_eduverse" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center nm-button-dark text-[#0B1C2D]"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.24 2.22.4a4.4 4.4 0 0 1 1.6.94 4.4 4.4 0 0 1 .94 1.6c.16.42.35 1.05.4 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.24 1.8-.4 2.22a4.4 4.4 0 0 1-.94 1.6 4.4 4.4 0 0 1-1.6.94c-.42.16-1.05.35-2.22.4-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.24-2.22-.4a4.4 4.4 0 0 1-1.6-.94 4.4 4.4 0 0 1-.94-1.6c-.16-.42-.35-1.05-.4-2.22-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.24-1.8.4-2.22a4.4 4.4 0 0 1 .94-1.6 4.4 4.4 0 0 1 1.6-.94c.42-.16 1.05-.35 2.22-.4 1.27-.06 1.65-.07 4.85-.07Zm0-2.16C8.74 0 8.33.01 7.05.07 5.78.13 4.9.34 4.15.63a6.6 6.6 0 0 0-2.39 1.56A6.6 6.6 0 0 0 .2 4.15C-.09 4.9-.3 5.78-.36 7.05-.42 8.33-.43 8.74-.43 12s.01 3.67.07 4.95c.06 1.27.27 2.15.56 2.9a6.6 6.6 0 0 0 1.56 2.39 6.6 6.6 0 0 0 2.39 1.56c.75.29 1.63.5 2.9.56 1.28.06 1.69.07 4.95.07s3.67-.01 4.95-.07c1.27-.06 2.15-.27 2.9-.56a6.6 6.6 0 0 0 2.39-1.56 6.6 6.6 0 0 0 1.56-2.39c.29-.75.5-1.63.56-2.9.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.27-2.15-.56-2.9a6.6 6.6 0 0 0-1.56-2.39A6.6 6.6 0 0 0 19.85.63C19.1.34 18.22.13 16.95.07 15.67.01 15.26 0 12 0Zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32Zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.4-10.88a1.44 1.44 0 1 0 0-2.88 1.44 1.44 0 0 0 0 2.88Z" />
                </svg>
              </a>
              {/* WhatsApp */}
              <a 
                href="https://wa.me/918639619079" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center nm-button-dark text-[#0B1C2D]"
                aria-label="WhatsApp"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M20.52 3.48A11.94 11.94 0 0 0 12.02 0C5.4 0 .02 5.38.02 12c0 2.11.55 4.17 1.6 6.01L0 24l6.16-1.6A11.94 11.94 0 0 0 12.02 24C18.64 24 24 18.62 24 12a11.94 11.94 0 0 0-3.48-8.52Zm-8.5 18.44c-1.93 0-3.82-.52-5.47-1.5l-.39-.23-3.65.95.98-3.56-.25-.4A9.9 9.9 0 0 1 2.1 12c0-5.45 4.45-9.9 9.92-9.9a9.9 9.9 0 0 1 9.9 9.9c0 5.47-4.45 9.92-9.9 9.92Zm5.44-7.43c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
                </svg>
              </a>
              {/* Call */}
              <a 
                href="tel:+918639619079" 
                className="w-10 h-10 rounded-full flex items-center justify-center nm-button-dark text-[#0B1C2D]"
                aria-label="Call Phone"
              >
                <svg viewBox="0 0 512 512" className="w-4 h-4" fill="currentColor">
                  <path d="M391.1 351.1c-20.6 0-41.2-3.2-60.8-9.4-9.3-2.9-19.5-.6-26.7 6.5l-37.6 28.3c-54.6-28.9-99-73.3-127.9-127.9l28.3-37.6c7.1-7.1 9.4-17.4 6.5-26.7-6.2-19.6-9.4-40.2-9.4-60.8C163.5 52.1 111.4 0 47.8 0H16C7.2 0 0 7.2 0 16c0 273.9 222.1 496 496 496 8.8 0 16-7.2 16-16v-31.8c0-63.6-52.1-115.7-120.9-115.7z" />
                </svg>
              </a>
            </div>
          </div>
          
          {/* Programs Column */}
          <div>
            <h4 className="text-[#0B1C2D] text-lg font-semibold mb-4 flex items-center">
              <span className="w-2 h-2 rounded-full bg-[#C6A25E] mr-3"></span>
              Our Verticals
            </h4>
            <ul className="space-y-2 text-slate-600 font-light">
              <li><a href="/junior-academy" className="hover:text-[#C6A25E] transition-colors py-1 block">Junior Academy</a></li>
              <li><a href="/elevare" className="hover:text-[#C6A25E] transition-colors py-1 block">Elevare (Career Prep)</a></li>
              <li><a href="/business-lab" className="hover:text-[#C6A25E] transition-colors py-1 block">Business Lab</a></li>
              <li><a href="/student-lms" className="hover:text-[#C6A25E] transition-colors py-1 block">Student LMS (Portal)</a></li>
            </ul>
          </div>
          
          {/* Links Column */}
          <div>
            <h4 className="text-[#0B1C2D] text-lg font-semibold mb-4 flex items-center">
              <span className="w-2 h-2 rounded-full bg-[#C6A25E] mr-3"></span>
              Quick Links
            </h4>
            <ul className="space-y-2 text-slate-600 font-light">
              <li><a href="/" className="hover:text-[#C6A25E] transition-colors py-1 block">Home</a></li>
              <li><a href="/#about" className="hover:text-[#C6A25E] transition-colors py-1 block">About Us</a></li>
              <li><a href="/testimonials" className="hover:text-[#C6A25E] transition-colors py-1 block">Testimonials</a></li>
              <li><a href="/book-demo" className="hover:text-[#C6A25E] transition-colors py-1 block font-semibold text-[#C6A25E]">Book Demo Session</a></li>
            </ul>
          </div>
          
          {/* Contact Column */}
          <div>
            <h4 className="text-[#0B1C2D] text-lg font-semibold mb-4 flex items-center">
              <span className="w-2 h-2 rounded-full bg-[#C6A25E] mr-3"></span>
              Contact Info
            </h4>
            <div className="space-y-3 text-slate-600 text-sm font-light">
              <div className="flex items-start">
                <span className="text-[#C6A25E] mr-2 mt-0.5 flex-shrink-0">📍</span>
                <a 
                  href="https://www.google.com/maps/place/Cervello+Eduverse+%7CCervello+Junior+Academy+%7CCervello+elevare+academy/@17.3553111,78.5057216,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb971b9eec41df:0xe134346aa0d8a993!8m2!3d17.3553111!4d78.5057216!16s%2Fg%2F11ytp6j2b2"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#C6A25E] transition-colors leading-relaxed"
                >
                  Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions, Hyderabad, Telangana - 500059
                </a>
              </div>
              <div className="flex items-center">
                <span className="text-[#C6A25E] mr-2 flex-shrink-0">✉️</span>
                <a href="mailto:cervelloeduverse@gmail.com" className="hover:text-[#C6A25E] transition-colors">
                  cervelloeduverse@gmail.com
                </a>
              </div>
              <div className="flex items-center">
                <span className="text-[#C6A25E] mr-2 flex-shrink-0">📞</span>
                <a href="tel:+918639619079" className="hover:text-[#C6A25E] transition-colors">
                  +91 86396 19079
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright and signature */}
        <div className="pt-8 border-t border-slate-200/50 text-center text-xs tracking-wider font-light text-slate-600">
          <p className="flex items-center justify-center gap-1.5">
            <span className="text-[#C6A25E] font-medium text-sm">©</span> 2025 cervello eduverse all rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
